/**
 * @file
 * Router Configuration
 * Used in library: vue-router
 *
 * Use this file to register the App routes
 * See https://router.vuejs.org/guide/#javascript
 * This configuration will be set in @/bootstrap/app.ts
 */

import {RouterOptions} from 'vue-router'

import ReportsDeliverySacPublicView from '@/views/reports/ReportsDeliverySacPublicView.vue'
import ReportsDeliverySacPublicResultView from '@/views/reports/ReportsDeliverySacPublicResultView.vue'

import ReportsDeliverySacAgcoPublicResultView from '@/views/reports/ReportsDeliverySacAgcoPublicResultView.vue'
import ReportsDeliverySacAgcoPublicView from '@/views/reports/ReportsDeliverySacAgcoPublicView.vue'
import ReportsDeliverySacPublicIvecoResultView from '@/views/reports/ReportsDeliverySacPublicIvecoResultView.vue'
import ReportsDeliverySacIvecoPublicView from '@/views/reports/ReportsDeliverySacIvecoPublicView.vue'
import ReportsDeliverySacBostonPublicView from '@/views/reports/ReportsDeliverySacBostonPublicView.vue'
import ReportsDeliverySacBostonPublicResultView from '@/views/reports/ReportsDeliverySacBostonPublicResultView.vue'

/**
 * VUE Router Configuration
 */
export const router: RouterOptions = {
  routes: [
    {path: '/', name: 'sac', component: ReportsDeliverySacPublicView},
    {
      path: '/dpk/result',
      name: 'sacDpk',
      component: ReportsDeliverySacPublicResultView,
    },
    {
      path: '/havanna/result',
      name: 'sacHavanna',
      component: ReportsDeliverySacPublicResultView,
    },
    {
        path: '/santillana/result',
        name: 'sacSantillana',
        component: ReportsDeliverySacPublicResultView,
    },
    {
      path: '/cnhIveco',
      name: 'sacCnhIveco',
      component: ReportsDeliverySacIvecoPublicView,
    },
    {
      path: '/cnhIveco/result',
      name: 'sacCnhIvecoResult',
      component: ReportsDeliverySacPublicIvecoResultView,
    },
    {
      path: '/cnhIveco/direct',
      name: 'sacCnhIvecoDirect',
      component: ReportsDeliverySacPublicIvecoResultView,
    },
    {
      path: '/agco',
      name: 'sacAgco',
      component: ReportsDeliverySacAgcoPublicView,
    },
    {
      path: '/agco/result',
      name: 'sacAgcoResult',
      component: ReportsDeliverySacAgcoPublicResultView,
      props: true,
    },
    {
      path: '/boston',
      name: 'sacBoston',
      component: ReportsDeliverySacBostonPublicView,
    },
    {
      path: '/boston/result',
      name: 'sacBostonResult',
      component: ReportsDeliverySacBostonPublicResultView,
      props: true,
    },
    {path: '/result', name: 'sacResult', component: ReportsDeliverySacPublicResultView},
    {path: '/result/:type', name: 'sacResultType', component: ReportsDeliverySacPublicResultView, props: true},
    {path: '*', redirect: '/'},
  ],
}
